
import { useNavigate } from "react-router-dom";

const StudentDetails = ({
  student,
}) => {
 
  const navigate = useNavigate();


  const isChalanPayed = student?.transactions?.find((t) => {
    const date = new Date().toISOString().split("T")[0].split("-")[0];

    const dateMatch = t.addedon.split(" ")[0].split("-")[0];
    if (dateMatch === date && t.status === "success" && t.amount === "50.00") {
      return t;
    }
  });

  const isApprovedAdmissionFee = student?.admissions?.admision_approved
    ? true
    : false;


  return (
    <div>
      <div className="main-dashboard-card">
        <div className="main-dashboard-card-header main-dashboard-helpdesk-header">
          <div>
            <h2 className="main-dashboard-card-title">Student Details</h2>
          </div>

          {!student.is_academic_filled && (
            <button
              onClick={() => navigate(`/student/profile`)}
              className="main-dashboard-status-badge main-dashboard-status-badge-pending"
            >
              Complete your profile
            </button>
          )}
        </div>
        <div className="main-dashboard-card-body">
          <div className="main-dashboard-list-header">
            <span className="main-dashboard-list-header-label">
              Student Name:
            </span>
            <span className="main-dashboard-list-header-label">
              {student?.name}
            </span>
          </div>

          <div className="main-dashboard-list-header">
            <span className="main-dashboard-list-header-label">Gender:</span>
            <span className="main-dashboard-list-header-label">
              {student?.gender}
            </span>
          </div>

          <div className="main-dashboard-list-header">
            <span className="main-dashboard-list-header-label">Category:</span>
            <span className="main-dashboard-list-header-label">
              {student?.category}
            </span>
          </div>
          <div className="main-dashboard-list-header">
            <span className="main-dashboard-list-header-label">Email:</span>
            <span className="main-dashboard-list-header-label">
              {student?.email}
            </span>
          </div>
          <div className="main-dashboard-list-header">
            <span className="main-dashboard-list-header-label">Phone:</span>
            <span className="main-dashboard-list-header-label">
              {student?.phone_number}
            </span>
          </div>
          <div className="main-dashboard-list-header">
            <span className="main-dashboard-list-header-label">Course:</span>
            <span className="main-dashboard-list-header-label">
              {student?.open_applications?.course_name ||
                student?.course_name ||
                student?.admissions?.stream}
            </span>
          </div>

       
          <div className="main-dashboard-list-header">
            <span className="main-dashboard-list-header-label">
              Chalan Payment Status:
            </span>
            <span className="main-dashboard-list-header-label">
              {isChalanPayed ? "Paid" : "Pending"}
            </span>
          </div>

          <div className="main-dashboard-list-header">
            <span className="main-dashboard-list-header-label">
              Admission Form Status:
            </span>
            <span className="main-dashboard-list-header-label">
              {isApprovedAdmissionFee ? "Approved" : "Pending"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentDetails;
